'use strict';

var common$1 = require('../../../../_virtual/common.js_commonjs-exports.js');

Object.defineProperty(common$1.__exports, "__esModule", {
  value: true
});
common$1.__exports.default = void 0;
var common = {
  black: '#000',
  white: '#fff'
};
var _default = common;
common$1.__exports.default = _default;
